module.exports = __webpack_public_path__ + "img/Brazilian.4db94246.svg";